import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';

import {loadTickerSearchList, selectTickerSearchList} from '../../../store/slices/globalResources.slice';


export const useTickerSearch = ({initialSymbols = []}) => {
  const dispatch = useDispatch();
  const tickers = useSelector(selectTickerSearchList);
  const loading = useSelector(state => state.global.status.tickerSearchList) === 'loading';
  const error = useSelector(state => state.global.error.tickerSearchList);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTickers, setFilteredTickers] = useState([]);
  const [selectedTickers, setSelectedTickers] = useState([]);

  useEffect(() => {
    if (!tickers || tickers.length === 0) {
      dispatch(loadTickerSearchList());
    }
  }, [dispatch]);
  useEffect(() => {
    if (tickers.length > 0 && initialSymbols.length > 0) {
      const initialSelectedTickers = initialSymbols
        .map((symbol) => tickers.find((ticker) => ticker.symbol === symbol))
        .filter((ticker) => ticker !== undefined); // filter out symbols that aren't found
      setSelectedTickers(initialSelectedTickers);
    }
  }, [tickers, initialSymbols]);

  const debouncedSearchTermUpdate = useCallback(debounce((newSearchTerm) => {
    setSearchTerm(newSearchTerm);
  }, 300), []);

  useEffect(() => {
    const matches = tickers.filter(ticker =>
      ticker.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticker.symbol.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredTickers(matches);
  }, [searchTerm, tickers]);

  const handleAddOrRemoveTicker = useCallback((record) => {
    setSelectedTickers(prev => {
      const alreadySelected = prev.some(ticker => ticker.symbol === record.symbol);
      return alreadySelected ? prev.filter(ticker => ticker.symbol !== record.symbol) : [...prev, record];
    });
  }, []);

  const handleRemoveTicker = useCallback((symbol) => {
    setSelectedTickers(prev => prev.filter(ticker => ticker.symbol !== symbol));
  }, []);

  return { tickers: filteredTickers, loading, error, selectedTickers, handleAddOrRemoveTicker, handleRemoveTicker, debouncedSearchTermUpdate };
};
